import ENDPOINTS from '../../const/endpoints';
export const authorizedBuyersLookupCacheKey = (membershipNumber) => [ENDPOINTS.authorizedBuyersLookup, { membershipNumber }];
